import axios from 'axios';
import { Dispatch } from 'react-redux';

import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import { navigateToTexts } from './navigationActions';
import ResponseStatus from '../utils/responseStatus';
import { isLoaded } from '../reducers/roleReducer';
import Text from '../entities/text';
import textItemTransformationBeforeSave from '../data-transformations/textItemTransformationBeforeSave';

export const fetchTexts = () => async (dispatch: Dispatch<any>, getState: any) => {
    if (isLoaded(getState())) {
        return;
    }

    try {
        dispatch(beginAjaxCall());

        const response = await axios.get(`text/`);

        if (ResponseStatus.IsOK(response.status)) {
            dispatch({
                type: types.TEXT_FETCH,
                data: response.data,
            });
        } else {
            dispatch(ajaxCallError());
        }
    } catch (error) {
        dispatch(ajaxCallError());
        throw error;
    }
};

export const createText = (data: Text) => (dispatch: Dispatch<any>) => {
    dispatch(beginAjaxCall());

    const transformedData = textItemTransformationBeforeSave(data);

    axios
        .post(`text`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsCreated(response.status)) {
                dispatch({
                    type: types.TEXT_ADD,
                });

                dispatch(navigateToTexts());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};

export const updateText = (data: Text) => (dispatch: Dispatch<any>) => {
    dispatch(beginAjaxCall());

    const transformedData = textItemTransformationBeforeSave(data);

    axios
        .put(`text`, transformedData)
        .then((response) => {
            if (ResponseStatus.IsOK(response.status)) {
                dispatch({
                    type: types.TEXT_UPDATE,
                    data: response.data,
                });

                dispatch(navigateToTexts());
            } else {
                dispatch(ajaxCallError());
            }
        })
        .catch((error) => {
            dispatch(ajaxCallError());
            throw error;
        });
};
